module.exports = __webpack_public_path__ + "img/sld_isolator_t1_b1_dark.94ab6df4.svg";